function WebAppTitle() {
    return (
        <div>
            <h1 className="hero-text">Web App Development</h1>
            <h1 className="hero-text">Projects</h1>
            <h5 className="hero-text">by Reymond Mesuga</h5>
        </div>
    )
}
export default WebAppTitle;  